




























import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { ILineStyle } from "../../../../../../../base/domain/drawing";
import { ILineGraphItem } from "../../../../../../../documaker/domain/format/objects";

@Component
export default class LineGraphItemSelector extends Mixins() {
  @Prop({ default: () => [] as ILineGraphItem[] })
  items: ILineGraphItem[];

  $refs!: {
    table: ElTable,
  };

  lineStyleProperties(style: ILineStyle) {
    return {
      backgroundColor: style.color.value,
      width: "20px",
      height: "20px",
    };
  }

  @Watch("items")
  onItemsUpdated(newValue: ILineGraphItem[], oldValue: ILineGraphItem[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  currentChange(value: ILineGraphItem): void {}
}
